/**
 * @file   src\mobile\components\GitchaGenie\SelectClient.js
 * @brief  This file is responsible for select client
 * @date   April, 2024
 * @author ZCO Engineer
 * @copyright (c) 2024, ZCO
 */
import { getInitials, removeLocalStorage } from "../../../helpers/common";
import Offcanvas from "react-bootstrap/Offcanvas";
import AddIcon from "../addIcn";
import { useState } from "react";
import AddNewClient from "../../commonComponents/ClientPopup";

const SelectClient = (props) => {
  const {
    selectedClient,
    setSelectedClient,
    clientList,
    setShowSelectClients,
    showSelectClients,
    reloadClientList,
  } = props;

  const [inputSearchValue, setInputSearchValue] = useState("");
  const [showAddNewClient, setAddNewClientShow] = useState(false);

  const handleSearchChange = (event) => {
    const searchtext = event.target.value;
    setInputSearchValue(searchtext);
    reloadClientList(searchtext);
  };

  const handleAddNewClientClose = () => {
    setAddNewClientShow(false);
    reloadClientList();
  };
  const handleAddNewClientShow = () => setAddNewClientShow(true);

  return (
    <>
      <Offcanvas
        className="mobile-offcanvas zIndexPopup offcanvas-selectclient-height-fix offcanvas-filter-share-fix"
        show={showSelectClients}
        onHide={setShowSelectClients}
        placement="bottom"
        {...props}
      >
        <Offcanvas.Header className="filter-offcanvas-header">
          <div className="share-yourad-topsec justify-content-center w-100 pt-32 mb-20">
            <div className="share-yourad-heading w-100 mt-0 mb-0 ">
              Select Client
            </div>
          </div>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <div className="offcanvas-sharead-wrap ">
            <div className="popupStyle">
              <div className="ps-3 pe-3 pb-3">
                <div className="search_field_input position-relative mb-0 input-group d-flex ">
                  <input
                    aria-label="Example"
                    aria-describedby="basic-addon3"
                    placeholder="Search clients"
                    className="form-control pr-0"
                    onChange={(e) => {
                      handleSearchChange(e);
                    }}
                  ></input>

                  <button
                    type="button"
                    id="button-addon3"
                    className="search-icon "
                  ></button>
                </div>
              </div>

              <div>
                <div className="modal-choose-property mb-0 ">
                  {clientList &&
                    clientList?.map((client) => {
                      return (
                        <label className="property-radio">
                          <input
                            type="radio"
                            name="check-box-option"
                            id="0"
                            onChange={() => {
                              setSelectedClient(client);
                              removeLocalStorage("selectedPropertyId");
                              props.setShowSelectClients(false);
                            }}
                            checked={selectedClient?.value === client?.value}
                            value={client?.value}
                          />

                          <span className="bdrRadius-0 ps-3 pe-3 ">
                            <div className="d-flex w-100">
                              <div
                                className={
                                  " profileIcnDiv me-2 align-items-center " +
                                  getInitials(
                                    client?.FirstName + " " + client?.LastName
                                  )?.backgroundColor
                                }
                              >
                                {" "}
                                {
                                  getInitials(
                                    client?.FirstName + " " + client?.LastName
                                  )?.initials
                                }
                              </div>
                              <div className="labelTxtName">
                                {" "}
                                {client?.FirstName + " " + client?.LastName}
                              </div>
                            </div>
                          </span>
                        </label>
                      );
                    })}
                </div>
              </div>
            </div>

            <div className="inner-btm-fixed-nav filter-btm-fixed-btnswrap">
              <div className="btn-wrap text-center pt-0">

                <button
                  type="button"
                  className="btn btn-primary addNew w-100 mb-40 add-new-client-btn"
                  onClick={handleAddNewClientShow}
                >
                  Add New Client <AddIcon />
                </button>
              </div>
            </div>
          </div>
        </Offcanvas.Body>
      </Offcanvas>

      <AddNewClient
        show={showAddNewClient}
        onHide={handleAddNewClientClose}
        clientDetails={null}
        isEdit={false}
      />
    </>
  );
};

export default SelectClient;
